import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const actions = {
  async info({ commit }, codigo) {// eslint-disable-line
    const data = await axios({
      method: 'get',
      url: `${modulo.PUBLICO}/arquivo/tipo/${codigo}`
    })

    return data
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/publico/legislacaoPortal.js